import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from '../style.css';

const NOOP = () => {};

function TopbarMenu({ toggle, children, ariaLabel, menuClassName = '', onOpenChange = NOOP }) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    const setOpenState = useCallback(
        value => {
            setOpen(value);
            onOpenChange(value);
        },
        [onOpenChange]
    );

    useEffect(() => {
        if (!open) return undefined;

        const onMouseDown = event => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpenState(false);
            }
        };
        const onKeyDown = event => {
            if (event.key === 'Escape') {
                setOpenState(false);
            }
        };
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('mousedown', onMouseDown);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [open, setOpenState]);

    return (
        <div className={css.menuContainer} ref={containerRef}>
            <button
                type="button"
                aria-label={ariaLabel}
                aria-expanded={open}
                className={css.menuToggle}
                onClick={() => setOpenState(!open)}
            >
                {toggle}
            </button>
            {open && (
                <div
                    className={classNames(css.menuPanel, menuClassName)}
                    onClick={event => {
                        if (!event.target.closest('[data-keep-open]')) {
                            setOpenState(false);
                        }
                    }}
                >
                    {children}
                </div>
            )}
        </div>
    );
}

TopbarMenu.propTypes = {
    toggle: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    menuClassName: PropTypes.string,
    onOpenChange: PropTypes.func,
};

export default TopbarMenu;
